module.exports = __webpack_public_path__ + "static/img/sq1.d719e52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sq1.png
// module id = +jR4
// module chunks = 1